var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"open-account-form-subsection",class:{ shadow: _vm.showShadow, 'no-border': _vm.noBorder }},[(_vm.title)?_c('h4',{class:{ 'with-caption': !!_vm.caption }},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),(_vm.caption)?_c('p',[_c('small',[_vm._v(_vm._s(_vm.caption))])]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }